import { IWizardStep } from "../../../wizard/types";
import Content from "./Content";
import { validator } from "./validator";

export const payForApplicationConfig: IWizardStep = {
  width: "720px",
  titleConfig: {
    titleText: "Create Receipt",
  },
  content: Content,
  validator: validator,
  stepName: "step1",
};
